module.exports = __webpack_public_path__ + "static/media/BBVA.606ceb6e.jpg";